import { defineMessages } from 'react-intl';

const _default_1: {
	jiraIssueTransitionTitle: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	jiraIssueTransitionSelectIssuesTitle: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	jiraIssueTransitionUpdateSelectedIssues: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	jiraIssueTransitionStatusTitle: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	jiraBulkIssueTransitionErrorMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraIssueTransitionActionCardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraIssueTransitionCancel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	jiraIssueTransitionTitle: {
		id: 'ai-mate.chat-history.store-assistant.message-actions.jira-issue-transition.title',
		description:
			"Message text displayed in an action card within the AI conversation interface when the AI suggests transitioning (updating the status of) multiple Jira work items. Shown as the main message text in the action card body. The purpose is to present the list of work items that match the user's request and provide clear instructions on how to proceed: select the items to update and then click the update button.",
		defaultMessage:
			"Here are the tickets that you asked for. Choose the ones you'd like to update, then select the update button.",
	},
	jiraIssueTransitionSelectIssuesTitle: {
		id: 'ai-mate.chat-history.store-assistant.message-actions.jira-issue-transition.select-issues-title',
		description:
			'Title text displayed above a checkbox or selection control in the Jira work item transition action card within the AI conversation interface. Shown as a section title or label. The purpose is to identify the "select all" control, which allows users to quickly select or deselect all work items in the list at once for bulk status updates.',
		defaultMessage: 'Select all work items',
	},
	jiraIssueTransitionUpdateSelectedIssues: {
		id: 'ai-mate.chat-history.store-assistant.message-actions.jira-issue-transition.update-selected-issues',
		description:
			'Button label displayed on the primary action button in the Jira work item transition action card within the AI conversation interface. Shown as the text on a button at the bottom of the action card. When clicked, it transitions all selected work items to the chosen status. The purpose is to provide a clear call-to-action for users to confirm and execute the status update for the selected work items.',
		defaultMessage: 'Update selected work items',
	},
	jiraIssueTransitionStatusTitle: {
		id: 'ai-mate.chat-history.store-assistant.message-actions.jira-issue-transition.status-title',
		description:
			'Label text displayed above or next to a status selector dropdown in the Jira work item transition action card within the AI conversation interface. Shown as a form field label. The purpose is to identify the status selector control, which allows users to choose which status the selected work items will be transitioned to (e.g., "In Progress", "Done", "To Do").',
		defaultMessage: 'Status',
	},
	jiraBulkIssueTransitionErrorMessage: {
		id: 'ai-mate.message-actions.jira-issue-transition.bulk-issue-transition-error-message',
		defaultMessage: 'Something went wrong while transitioning the work item.',
		description:
			'Error message displayed in the AI conversation interface when an error occurs while transitioning (updating the status of) one or more Jira work items. Shown as an error message in the chat history or in an error notification. The purpose is to inform the user that the status transition encountered an error and could not be completed, prompting them to try again or check for issues.',
	},
	jiraIssueTransitionActionCardTitle: {
		id: 'ai-mate.chat-history.store-assistant.message-actions.jira-issue-transition.action-card-title',
		defaultMessage: 'Update selected work items',
		description:
			'Title text displayed at the top of an action card in the AI conversation interface when the AI suggests updating the status of multiple Jira work items. Shown as the card header title. The purpose is to immediately communicate to the user what action the card represents, which is updating the status of selected work items.',
	},
	jiraIssueTransitionCancel: {
		id: 'ai-mate.chat-history.store-assistant.message-actions.jira-issue-transition.cancel',
		defaultMessage: 'Cancel',
		description:
			'Button label displayed on the secondary action button in the Jira work item transition action card within the AI conversation interface. Shown as the text on a button at the bottom of the action card next to the update button. When clicked, it cancels the suggested status updates and informs the AI assistant that the user declined the suggested action. The purpose is to provide a clear way for the user to reject the AI suggestion.',
	},
});
export default _default_1;
